export const CHART_BRAND_COLORS = {
  green1: '#00A193',
  green6: '#009776',
  green9: '#007058',
  green10: '#2DCFAC',
  gold2: '#F5A512',
  gold7: '#bd7e09',
  gold9: '#fab32f',
  darkBlue3: '#000433',
  blue4: '#395468',
  blue8: '#284255',
  blue11: '#50697C',
  grey5: '#7C848F',
  grey11: '#BEBEBE',
  grey12: '#344051',
  green13: '#6BD7BF',
}

export const REVIEWER_TYPES = {
  ha_tenant: {
    label: 'HA Tenant',
    color: CHART_BRAND_COLORS.green1,
    benchmarkColor: CHART_BRAND_COLORS.green1,
  },
  la_tenant: {
    label: 'LA Tenant',
    color: CHART_BRAND_COLORS.gold2,
    benchmarkColor: CHART_BRAND_COLORS.darkBlue3,
  },
  owner: {
    label: 'Owner',
    color: CHART_BRAND_COLORS.darkBlue3,
    benchmarkColor: CHART_BRAND_COLORS.blue4,
  },
  shared_owner: {
    label: 'Shared Owner',
    color: CHART_BRAND_COLORS.blue4,
    benchmarkColor: CHART_BRAND_COLORS.grey5,
  },
  tenant: {
    label: 'Private Tenant',
    color: CHART_BRAND_COLORS.grey5,
    benchmarkColor: CHART_BRAND_COLORS.green6,
  },
  pro: {
    label: 'Pro',
    color: CHART_BRAND_COLORS.green6,
    benchmarkColor: CHART_BRAND_COLORS.green6,
  },
  visitor: {
    label: 'Visitor',
    color: CHART_BRAND_COLORS.gold7,
    benchmarkColor: CHART_BRAND_COLORS.blue8,
  },
}

export const RATING_TYPES_DETAILED = {
  rating: {
    label: 'Overall',
  },
  rating_facilities: {
    label: 'Facilities',
  },
  rating_location: {
    label: 'Location',
  },
  rating_value: {
    label: 'Value',
  },
  rating_design: {
    label: 'Design',
  },
  rating_management: {
    label: 'Management',
  },
}

export const RATING_TYPES = {
  rating: 'Overall',
  rating_facilities: 'Facilities',
  rating_location: 'Location',
  rating_value: 'Value',
  rating_design: 'Design',
  rating_management: 'Management',
}

export const CHART_COLORS = {
  blue: '#27A5D6',
  lightBlue: '#0093B1',
  yellow: '#FFCC5D',
  purple: '#805589',
  green: '#00DEB6',
  lightGreen: '#97E066',
  red: '#E13F2D',
  lighterRed: '#EE4A5C',
  turquoise: '#80E5D6',
  black: '#000000',
  darkGrey: '#4E516B',
  gold: '#F5A512',
  benchmarkColor: '#F5A512',
}

export const CHART_COLORS_NON_BENCHMARK_ARRAY = [
  CHART_BRAND_COLORS.green1,
  CHART_BRAND_COLORS.gold2,
  CHART_BRAND_COLORS.darkBlue3,
  CHART_BRAND_COLORS.blue4,
  CHART_BRAND_COLORS.grey5,
  CHART_BRAND_COLORS.green6,
  CHART_BRAND_COLORS.gold7,
  CHART_BRAND_COLORS.blue8,
  CHART_BRAND_COLORS.gold9,
  CHART_BRAND_COLORS.green10,
  CHART_BRAND_COLORS.blue11,
  CHART_BRAND_COLORS.green9,
]

export const CHART_COLORS_BENCHMARK_ARRAY = [
  CHART_BRAND_COLORS.green1,
  CHART_BRAND_COLORS.darkBlue3,
  CHART_BRAND_COLORS.blue4,
  CHART_BRAND_COLORS.grey5,
  CHART_BRAND_COLORS.green6,
  CHART_BRAND_COLORS.blue8,
  CHART_BRAND_COLORS.green10,
  CHART_BRAND_COLORS.blue11,
  CHART_BRAND_COLORS.green9,
  CHART_BRAND_COLORS.grey12,
  CHART_BRAND_COLORS.green13,
  CHART_BRAND_COLORS.grey11,
]

export const DEVELOPMENT_SCORES_CATEGORY_OPTIONS = [
  {
    label: 'Overall Review Rating',
    value: 'rating',
  },
  {
    label: 'Rating Design',
    value: 'rating_design',
  },
  {
    label: 'Rating Facilities',
    value: 'rating_facilities',
  },
  {
    label: 'Rating Location',
    value: 'rating_location',
  },
  {
    label: 'Rating Value',
    value: 'rating_value',
  },
  {
    label: 'Rating Management',
    value: 'rating_management',
  },
]

export const REVIEWER_AGES = {
  '18-24': {
    label: '18-24',
    color: CHART_BRAND_COLORS.green1,
    order: 1,
    value: '18-24',
  },
  '25-34': {
    label: '25-34',
    color: CHART_BRAND_COLORS.gold2,
    order: 2,
    value: '25-34',
  },
  '35-44': {
    label: '35-44',
    color: CHART_BRAND_COLORS.darkBlue3,
    order: 3,
    value: '35-44',
  },
  '45-54': {
    label: '45-54',
    color: CHART_BRAND_COLORS.blue4,
    order: 4,
    value: '45-54',
  },
  '55-64': {
    label: '55-64',
    color: CHART_BRAND_COLORS.grey5,
    order: 5,
    value: '55-64',
  },
  '65-': {
    label: '65+',
    color: CHART_BRAND_COLORS.green6,
    order: 6,
    value: '65-200',
  },
}

export const SUSTAINABILITY = {
  sustainability_renewable_energy: {
    id: 'Renewable energy sources',
    label: 'Renewable energy sources',
    color: '#97E066',
  },
  sustainability_recycling_services: {
    id: 'Recycling services',
    label: 'Recycling services',
    color: '#805589',
  },
  sustainability_building_eco_ratings: {
    id: 'Building environmental ratings',
    label: 'Building environmental ratings',
    color: '#805589',
  },
  sustainability_energy_saving_measures: {
    id: 'Energy saving measures',
    label: 'Energy saving measures',
    color: '#FFCC5D',
  },
  sustainability_bike_storage: {
    id: 'Bike storage',
    label: 'Bike storage',
    color: '#4E516B',
  },
  sustainability_parking_alternatives: {
    id: 'Parking alternatives',
    label: 'Parking alternatives',
    color: '#80E5D6',
  },
  sustainability_sustainable_construction: {
    id: 'Sustainable building materials and construction methods',
    label: 'Sustainable building materials and construction methods',
    color: '#F6A44D',
  },
  sustainability_private_space: {
    id: 'Access to private green space',
    label: 'Access to private green space',
    color: '#66E074',
  },
  sustainability_smart_features: {
    id: 'Smart features to improve facilities management',
    label: 'Smart features to improve facilities management',
    color: '#664F8E',
  },
  sustainability_other: {
    id: 'Other',
    label: 'Other',
    color: '#7C848F',
  },
}

export const SUSTAINABILITY_LABELS_MAP = {
  'Building environmental ratings': ['Building environmental', 'ratings'],
  'Sustainable building materials and construction methods': [
    'Sustainable building',
    'materials and construction',
    'methods',
  ],
  'Access to private green space': ['Access to private green', 'space'],
  'Smart features to improve facilities management': [
    'Smart features to improve',
    'facilities management',
  ],
}

export const MD_SUSTAINABILITY_LABELS_MAP = {
  'Renewable energy sources': ['Renewable', 'energy', 'sources'],
  'Recycling services': ['Recycling', 'services'],
  'Building environmental ratings': ['Building', ' environmental', 'ratings'],
  'Energy saving measures': ['Energy', 'saving', 'measures'],
  'Sustainable building materials and construction methods': [
    'Sustainable',
    'building',
    'materials and',
    'construction methods',
  ],
  'Access to private green space': ['Access to', 'private green', 'space'],
  'Smart features to improve facilities management': [
    'Smart features',
    'to improve facilities',
    'management',
  ],
  'Parking alternatives': ['Parking', 'alternatives'],
}
